export default __webpack_public_path__ + "static/media/tennisBanner.5e142c60.jpg";